import { API_RESOURCE } from '@/constants/api.constant'
import { axios } from '@/lib/axios'
import { createQueryKey } from '@/lib/react-query'
import CrudService from '@/services/crudService'

const resource = API_RESOURCE.ANNOUNCEMENT

const AnnouncementService = {
  resource,
  queryKey: createQueryKey(resource),
  ...CrudService(resource),

  fetchAnnouncementByType: async (type) => {
    const response = await axios.get(`${AnnouncementService.resource}/type/${type}`)
    return response.data
  },
}

export default AnnouncementService
